'use strict';

var defineProperty = require('../../node_modules/@babel/runtime/helpers/defineProperty.js');
var React = require('react');
var iconStyles = require('../iconStyles.js');
var SvgIcon = require('../../node_modules/@material-ui/core/esm/SvgIcon/SvgIcon.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var GenericCardLogo = function GenericCardLogo(props) {
  return React__default["default"].createElement(SvgIcon["default"], _objectSpread({}, props, {
    viewBox: "0 0 145.27 93.77"
  }), React__default["default"].createElement("defs", null, React__default["default"].createElement("style", null, ".generic-card-logo-cls-2{fill:none;stroke:#151a1f;stroke-linecap:round;stroke-linejoin:round;stroke-width:5.81px}")), React__default["default"].createElement("g", null, React__default["default"].createElement("path", {
    style: {
      fill: "#2b76bc"
    },
    d: "M2.9 19.08h139.47V32.9H2.9z"
  }), React__default["default"].createElement("rect", {
    className: "generic-card-logo-cls-2",
    x: 2.9,
    y: 2.9,
    width: 139.47,
    height: 87.96,
    rx: 8.78,
    ry: 8.78
  }), React__default["default"].createElement("path", {
    className: "generic-card-logo-cls-2",
    d: "M19.48 50.83h46.7"
  })));
};

var GenericCardLogo$1 = iconStyles()(GenericCardLogo);

module.exports = GenericCardLogo$1;
